<template>
	<div class="page-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="cmd" @eventProblemCode="changePage"></HeaderLayout>
		
		 <div class="content">
			<!-- ul class="box-list-1">
			        <li @click="showCategory()">{{gtypeName}}<span class="icon-1"><img src="../../assets/img/btn-arrow.png" width=15 height=15></span></li>
			</ul -->
			<div class="content-main-1"  id="data-box">
					 <div class="box-left">
			                <div class="box-map">
	   			                  <h1 class="text-name">{{userName}}의 성적
				                  </h1>
				                  <div style='width:100%;margin:43px auto 10px auto;height:260px;'>
										<canvas id="radarChart" style="width:100%;height:260px;"></canvas>
								  </div>
				                  <ul class="box-list">
				                  	    <li><span class="radius-red"></span>{{bottomText1}}</li>
				                  	    <li><span class="radius-red" style=" background:#3D79FF"></span>{{bottomText2}}</li>
				                  </ul>
				            </div>
				            
                    </div>
					<div class="box-right">
					      <div class="box-card">
						       성적평
							   <ul class="box-list-card">
							   		<li>{{leftUserName}} 전국 평균에 비해</li>
									
									<li v-for="data in eval_category"><span class="text">{<span>{{data.name}}</span>}</span>에서 {{data.report}}</li>
							   </ul>
						  </div>
						  <div class="box-card" style='background:none;'>
						       <!--평가힝목 및 통계
							   <ul class="box-list-card">
							   		<li class="text-list">기획 필요</li>
							   </ul-->
						  </div>
				   </div>
			 </div>  
			 <div class="content-main-1" style="background:#fff;height:400px;line-height:200px;text-align:center;display:none" id="nodata-box">
			 	<h3>데이타가 존재하지 않습니다</h3>
			 </div>
	   </div>
	   <div class="screenLayout" v-if="screenView">
			<div class="content-wrapper">
				<div class="content-box">
					<span @click="screenView=false"><i class="fa fa-times"></i></span>
					<ul style="max-height:230px;overflow-y:auto;">
						<li v-for="name,key in categorys" style='cursor:pointer;' @click="searchList(key)">{{name}}</li>
					</ul>
				</div>
			</div>
		</div>
	    <FooterLayout></FooterLayout>
	</div>
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'


export default {
	name: 'problemUserReport',
	components: {
  		HeaderLayout,
		FooterLayout
	},
	data() {

		  return {
			  	userName:'',
				eval_category:{},
				pagecode:'myreport',
				cmd:'ai',
				leftUserName:'',
				bottomText1:'',
				bottomText2:'',
				chart:null,
				gtypeName:'수능',
				gtype:'a',
				categorys:[],
				screenView:false,
				
		  }
	},
	created() {
		if(sessionStorage.getItem('memberkey'))this.getData();
		
	},
    methods: {
	  getData() {
		  	var obj = this;
			this.$form.sendPost({cmd:this.cmd,gtype:this.gtype},'problem/getTestAllResult',function(resp) {
				if(resp.result!='succ') {
					alert('잘못된 접근입니다');
					obj.$router.push({path:'/'});
					return;
				} else {
					obj.categorys = resp.gtypeList;
					if(obj.cmd=='ai') {
						obj.userName = 'NOSTRA A.I 아바타';
						obj.leftUserName = '내 아바타는';
						obj.bottomText1 = '전국 아바타 평균',
						obj.bottomText2 = '내 아바타';
				    } else {
						obj.userName = resp.userName+'님';
						obj.leftUserName = resp.userName+'님은';
						obj.bottomText1 = '전국 학생 평균',
						obj.bottomText2 = '내 점수';
					}
					obj.eval_category = resp.eval_category;
					obj.getGraph(obj.eval_category,resp.maxCategoryTotal);
					
				}
			});
	  
	  },
	  getGraph(category,max) {
		if(category.length<1) {
			$('#data-box').hide();
			$('#nodata-box').show();
			return;
		} else {
			$('#data-box').show();
			$('#nodata-box').hide();

		}
		var labels = [];
		var allData = [];
		var userData = [];

		for(var k in category) {
			var item = category[k];
			labels.push(item.name);
			userData.push(item.user);
			allData.push(item.total);
		}

		Chart.defaults.global.defaultFontColor = "#000";
		Chart.defaults.global.pointLabelFontSize = 20;
		Chart.defaults.global.defaultFontSize = 13;

		var radarData = {
			labels: labels,
			datasets: [{
				label: false,
				data: userData,
				backgroundColor: "rgba(61,121,255,0.4)",
				pointBackgroundColor:'#3D79FF',
				pointRadius:4,
				borderColor: "#3D79FF",
				borderWidth: 1,
				pointLabelFontSize: 1,
			},
			{
				label: false,
				data: allData,
				backgroundColor: "rgba(254,59,0,0.4)",
				pointBackgroundColor:'#FE3B00',
				pointRadius:4,
				borderColor: "#FE3B00",
				borderWidth: 1,
				pointLabelFontSize: 1,
			}]
		};

		var radarOptions = {
		  elements: {
		    point: {
		      radius: 2
		    }
		  },
		  responsive: false,
		  maintainAspectRatio: false,
		  scale: {
		    pointLabels: {
		      fontSize: 13,
		      color: "#444"
		    },
		    angleLines: {
		      display: true,
		      color: "#555"
		    },
		    gridLines: {
		      color: "#555",
		      tickMarkLength: 3
		    },
		    ticks: {
		      label: false,
		      min: 0,
		      max: max,
		      fixedStepSize: parseInt(max/5),
		      showLabelBackdrop: false,
		      fontSize: 0,
		      color: "#eee",
		    }
		  },
		  title: {
		    display: false
		  },
		  legend: {
		    display: false,
		  }
		};
		var ctx5 = document.getElementById("radarChart").getContext("2d");

		new Chart(ctx5, {
		  type: 'radar',
		  data: radarData,
		  options: radarOptions
		});
	},
	showTab(code) {
		this.cmd  = code;
		$('.header .box-list li').removeClass('active');
		if(code == 'ai') {
			$('.header .box-list li').eq(0).addClass('active');
		} else {
			$('.header .box-list li').eq(1).addClass('active');
		}
		this.getData();
	},
	showCategory() {
			this.screenView = true;
		
	},
	 searchList(key) {
			this.gtype = key;
			this.gtypeName = this.categorys[key];
			this.getData();
			this.screenView = false;
	}, 
	changePage(code) {
		this.cmd  = code;
		this.getData();
	}

	  
	  
  },
  mounted() {
	
  },
  updated() {
	
  }

}
</script>

<style lang="scss" scoped>
.page-container {
	width:100%;
	min-height:calc(100vh);
	background:#E6E8F4;
	.content   {
		width:100%;
		padding:175px 0 55px 0; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#E6E8F4;
		overflow:auto;
		.box-list-1		{
										width:800px;
										padding:0 5px;
										margin:0 auto 20px auto;
li  {
										     padding:10px 12px;
											 border:1px solid #A8A8A8;
											 border-radius:20px;
											 font-family: 'Nanum Gothic', sans-serif;
										     font-size:14px;
										     color:#000;
											 position:relative;
											 text-align:center;
											 background-color:#fff;
											 cursor:pointer;
											 margin-left:30px;
											 .icon-1		{
											 		display:inline-block;
													position:absolute;
													right:12px;
													top:7px;
													
											 }
										}
		}
		.content-main-1 {
			  					width:800px;
								height:auto;
								margin:0 auto;
								.box-left        {
									      float:left;
										  width:500px;
										  background:#fff;
										  height:550px;
										  padding-top:40px;
										  .box-map          {
										  		     text-align:center;
													 width:458px;
													 margin:0 auto;
													 padding-bottom:15px;
													 .text-name         {
													            font-size:18px;
																line-height:23px;
																color:#4E4E4E;
													 }
													 img                {
													 			padding:40px 0;
													 }
													 .box-list			{
													 			display:flex;
																width:210px;
																margin:0 auto;
																li             {
																		font-size:11px;
																		color:#000;
																		margin-left:20px;
																		.radius-red       {
																					 display:inline-block;
																					 width:9px;
																					 height:9px;
																					 border-radius:50%;
																					 background:#FD3A00;
																					 margin-right:5px;
																		}
																}
													 }
										  }
										  .box-menu          {
										  			  width:512px;
													  margin:15px 0;
													  ul             {
													  		  margin-top:2px;
															  display:flex;
															  li            {
															  		 width:33%;
																	 text-align:center;
																	 font-size:11px;
															  }
													  }
													  ul.box-two          {
													  			li          {
																	  font-size:20px;
																	  .text-a         {
																	  		   font-size:14px;
																	  }
																}
													  }
													  ul.box-free          {
													  			 li            {
																 		color:#A6A6A6;
																		font-size:12px;
																 }
													  }
										  }
								}
								.box-right        {
										  float:right;
										  width:280px;
										
										  .box-card         {
										  	        width:305px;
													padding:25px 0 15px;
													background:#fff;
													text-align:center;
													font-size:16px;
													color:#333333;
													&:last-child        {
															    margin-top:10px;
													}
													.box-list-card       {
																   width:240px;
																   margin:10px auto;
																   height:190px;
																   background:#F4F4F4;
																   padding:50px 30px;
																   li                 {
																   			  font-size:12px;
																			  font-weight:bold;
																			  color:#2C2C2C;
																			  .text          {
																			  			color:#3D79FF;
																			  }
																   }
																   .text-list       {
																   			 margin-top:30px;
																   }
														
													}
										  }
									}
		}
	}
	
}
</style>